import React, { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import { CheckableBaseStyle } from './CheckableBase.styles.js';
import 'polished';
import '@s-group/design-system-tokens/web/tokens/size.es6.js';
import { useSimpleId } from '../common/hooks.js';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from '../FormRow/FormRowContext.js';

const defaultProps = {
    alternative: false,
    disabled: false,
    error: false,
    sizing: 'medium',
};
const _CheckableBase = forwardRef(({ alternative, className, children, error, id: propId, indicator: Indicator, labelProps, sizing, theme, // Discard unused theme prop that styled-components passes here
...rest }, ref) => {
    const id = propId ? propId : useSimpleId();
    return (React.createElement("label", { ...labelProps, className: className, htmlFor: id },
        React.createElement("input", { ...rest, id: id, ref: ref }),
        React.createElement(Indicator, { "aria-hidden": "true", className: "indicator", sizing: sizing !== null && sizing !== void 0 ? sizing : defaultProps.sizing }),
        children));
});
_CheckableBase.displayName = '_CheckableBase';
const CheckableBase = styled(_CheckableBase).attrs(({ alternative, sizing }) => {
    var _a, _b, _c, _d;
    const formRowContext = useContext(FormRowContext);
    const formContext = useContext(FormContext);
    return {
        alternative: (_b = (_a = alternative !== null && alternative !== void 0 ? alternative : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.alternative) !== null && _a !== void 0 ? _a : formContext === null || formContext === void 0 ? void 0 : formContext.alternative) !== null && _b !== void 0 ? _b : defaultProps.alternative,
        sizing: (_d = (_c = sizing !== null && sizing !== void 0 ? sizing : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.sizing) !== null && _c !== void 0 ? _c : formContext === null || formContext === void 0 ? void 0 : formContext.sizing) !== null && _d !== void 0 ? _d : defaultProps.sizing,
    };
}) `
    ${CheckableBaseStyle}
`;

export { CheckableBase, defaultProps };
//# sourceMappingURL=CheckableBase.js.map
